const Graph = require('./BaseGraph')

module.exports = class ContentGraph extends Graph 
{
    constructor(apiDomain, path="content")
    {
        super(apiDomain, path)
    }
    
    categoriesQuery(fields, params=null)
    {
        if (params)
            return { type: 'categories', query: this.queryString('categories', fields, params) }

        return { type: 'categories', query: `query getCategories ($section: String, $parent: String, $tags: [String], $sort: String, $limit: Int, $offset: Int) {
            categories(section: $section, parent: $parent, tags: $tags, sort: $sort, limit: $limit, offset: $offset)
            ${this.queryFields(fields)}
        }` }
    }
    
    articlesQuery(fields, params=null)
    {
        if (params)
            return { type: 'articles', query: this.queryString('articles', fields, params) }

        return {
          type: 'articles',
          query: `query getArticles ($section: String, $category: String, $type: Int, $except_id: ID, $except_types: [Int], $search: String, $tags: [String], $sort: String, $limit: Int, $offset: Int, $percentage: [Int], $country: String) {
            articles(section: $section, category: $category, type: $type, except_id: $except_id, except_types: $except_types, search: $search, tags: $tags, sort: $sort, limit: $limit, offset: $offset, percentage: $percentage, country: $country)
            ${this.queryFields(fields)}
        }`,
        };
    }

    articleQuery(fields, params=null)
    {
        if (params)
            return { type: 'article', query: this.queryString('article', fields, params) }

        return { type: 'article', query: `query getArticle ($slug: String, $country: String) {
            article(slug: $slug, country: $country)
            ${this.queryFields(fields)}
        }` }
    }

    categoryQuery(fields, params=null)
    {
        if (params)
            return { type: 'category', query: this.queryString('category', fields, params) }

        return { type: 'category', query: `query getCategory ($section: String, $slug: String) {
            category(section: $section, slug: $slug)
            ${this.queryFields(fields)}
        }` }
    }

    contentDetailsQuery(fields, params=null)
    {
        if (params)
            return { type: 'details', query: this.queryString('details', fields, params) }

        return { type: 'details', query: `query getDetails($content_id: Int!, $user_id: String, $contact_id: String) {
            details(contact_id: $contact_id, user_id: $user_id, contact_id: $contact_id)
            ${this.queryFields(fields)}
        }` }
    }

    submitDetailsMutation(fields, params=null)
    {
        if (params)
            return { type: 'submitDetails', query: `mutation {
                submitDetails(${this.queryParams(params)})
                ${this.queryFields(fields)}
            }` }

        return { type: 'submitDetails', query: `mutation submitDetails ($content_id: Int!, $user_id: String, $contact_id: String, $is_read: Int, $is_watched: Int, $is_downloaded: Int, $played: String, $percentage: String) {
            submitDetails(content_id: $content_id, user_id: $user_id, contact_id: $contact_id, is_read: $is_read, is_watched: $is_watched, is_downloaded: $is_downloaded, played: $played, percentage: $percentage)
            ${this.queryFields(fields)}
        }` }
    }

}